var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('tg-header-bar'),_c('tg-about-bar'),_c('tg-about-card'),_c('tg-footer-bar',{attrs:{"pcHref":_vm.pcHref}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }